import Vue from 'vue';
import Router from 'vue-router';
import {reportLog} from '../assets/js/log.js';
import main from '@/components/main';
Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: '/clsgdbv2/',
  routes: [
    {
      path: '/',
      name: 'Main',
      redirect: '/',
      component: main,
      children: [
        {
          path: '/',
          name: 'Home',
          component: () => import('@/views/home/index')
        }
        // {
        //     path: '/database',
        //     name: 'Database',
        //     component: () => import('@/views/database/index')
        // },
        // {
        //     path: '/mlst',
        //     name: 'Mlst',
        //     component: () => import('@/views/mlst/index')
        // },
        // {
        //     path: '/resistome',
        //     name: 'Resistome',
        //     component: () => import('@/views/resistome/index')
        // },
        // {
        //     path: '/mobilome',
        //     name: 'Mobilome',
        //     component: () => import('@/views/mobilome/index')
        // },{
        //     path: '/drivers',
        //     name: 'Drivers',
        //     component: () => import('@/views/drivers/index')
        // },{
        //     path: '/download',
        //     name: 'Download',
        //     component: () => import('@/views/download/index')
        // },{
        //     path: '/contact',
        //     name: 'Contact',
        //     component: () => import('@/views/contact/index')
        // },
      ]
    },
    // {
    //     path: '/',
    //     name: 'Home',
    //     component: () => import('@/views/home/index')
    // },
    {
      path: '/database',
      name: 'Database',
      component: () => import('@/views/database/index')
    }, {
      path: '/mlst',
      name: 'Mlst',
      component: () => import('@/views/mlst/index')
    },
    {
      path: '/resistome',
      name: 'Resistome',
      component: () => import('@/views/resistome/index')
    },
    {
      path: '/mobilome',
      name: 'Mobilome',
      component: () => import('@/views/mobilome/index')
    }, {
      path: '/drivers',
      name: 'Drivers',
      component: () => import('@/views/drivers/index')
    }, {
      path: '/download',
      name: 'Download',
      component: () => import('@/views/download/index')
    }, {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/contact/index')
    }

  ]
});

router.afterEach((to, from) => {
  reportLog('CLSGDB v2');
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js